import { render, staticRenderFns } from "./BlogTextColor.vue?vue&type=template&id=4123a254"
import script from "./BlogTextColor.vue?vue&type=script&lang=js"
export * from "./BlogTextColor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports